import React, { Component } from 'react'
import { IconButton, Select, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core'
import './style.scss'
import { Edit } from '@material-ui/icons'

const products = [{
  url: '/images/3.jpg',
  name: 'Scarpin Napa',
  reference: 374260002,
  grid: [[34, 35, 36, 37, 38, 39, 40], [0, 0, 0, 0, 0, 0, 0]],
  money: 39.2,
  quentified: 0,
  total: 0
}, {
  url: '/images/3.jpg',
  name: 'Scarpin Napa',
  reference: 374260002,
  grid: [[34, 35, 36, 37, 38, 39, 40], [0, 0, 0, 0, 0, 0, 0]],
  money: 39.2,
  quentified: 0,
  total: 0
}, {
  url: '/images/3.jpg',
  name: 'Scarpin Napa',
  reference: 374260002,
  grid: [[34, 35, 36, 37, 38, 39, 40], [0, 0, 0, 0, 0, 0, 0]],
  money: 39.2,
  quentified: 0,
  total: 0
}, {
  url: '/images/3.jpg',
  name: 'Scarpin Napa',
  reference: 374260002,
  grid: [[34, 35, 36, 37, 38, 39, 40], [0, 0, 0, 0, 0, 0, 0]],
  money: 39.2,
  quentified: 0,
  total: 0
}, {
  url: '/images/3.jpg',
  name: 'Scarpin Napa',
  reference: 374260002,
  grid: [[34, 35, 36, 37, 38, 39, 40], [0, 0, 0, 0, 0, 0, 0]],
  money: 39.2,
  quentified: 0,
  total: 0
}, {
  url: '/images/3.jpg',
  name: 'Scarpin Napa',
  reference: 374260002,
  grid: [[34, 35, 36, 37, 38, 39, 40], [0, 0, 0, 0, 0, 0, 0]],
  money: 39.2,
  quentified: 0,
  total: 0
}, {
  url: '/images/3.jpg',
  name: 'Scarpin Napa',
  reference: 374260002,
  grid: [[34, 35, 36, 37, 38, 39, 40], [0, 0, 0, 0, 0, 0, 0]],
  money: 39.2,
  quentified: 0,
  total: 0
}, {
  url: '/images/3.jpg',
  name: 'Scarpin Napa',
  reference: 374260002,
  grid: [[34, 35, 36, 37, 38, 39, 40], [0, 0, 0, 0, 0, 0, 0]],
  money: 39.2,
  quentified: 0,
  total: 0
}, {
  url: '/images/3.jpg',
  name: 'Scarpin Napa',
  reference: 374260002,
  grid: [[34, 35, 36, 37, 38, 39, 40], [0, 0, 0, 0, 0, 0, 0]],
  money: 39.2,
  quentified: 0,
  total: 0
}];
const selectItems = ['0AA', '9A', '9B', '10A', '10B', '10C', '12A', '12B', '12C', '12D', '15A', '15B', '15C', '15D', '15E', '16A', '16B', '16C', '16D', '16E'];
class CartDetails extends Component {
  constructor(props) {
    super(props);

    this.state = { openSelect: false, selectLeft: 0, selectTop: 0 };
  }
  renderPhoto = (url, name, reference) => (
    <div className="product-photo">
      <div className="photo" style={{ backgroundImage: `url(${url})` }}></div>
      <div className="content">
        <div>{name}</div>
        <div>Refernce:<i>{reference}</i></div>
      </div>
    </div>
  )
  onEdit = (e) => {
    var x = e.screenX;
    var y = e.screenY;
    this.setState((state) => {

      return { openSelect: true, selectLeft: x, selectTop: y };
    });
  }
  handleCloseSelect = () => {
    this.setState(() => {
      return { openSelect: false };
    });
  };
  render() {
    const styleObj = {
      position: 'absolute',
      top: this.state.selectTop + "px",
      left: this.state.selectLeft + "px",
      display: this.state.openSelect ? 'block' : 'none'
    }
    return (
      <div className="cart-details-page">
        <div style={styleObj}>
          <Select open={this.state.openSelect} autoWidth={true} fullWidth={'120px'} onClose={this.handleCloseSelect}>
            {selectItems.map((element, index) => {
              return (<p className="select-item" style={({ marginLeft: '12px', marginRight: '24px' })}>{element} </p>);
            })}</Select>
        </div>

        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name do Produto</TableCell>
              <TableCell>Grade</TableCell>
              <TableCell>Valor</TableCell>
              <TableCell>Quantidade</TableCell>
              <TableCell>Total</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {products.map((element, index) => {
              return (
                <TableRow key={index}>
                  <TableCell>{this.renderPhoto(element.url, element.name, element.reference)}</TableCell>
                  <TableCell>
                    <Table>
                      {element.grid.map((row, index) => (
                        <TableRow key={index}>
                          {row.map((col, index) => (
                            <TableCell key={index}>{col}</TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </Table>
                  </TableCell>
                  <TableCell>R${element.money.toFixed(2)}</TableCell>
                  <TableCell>
                    <div>0</div>
                    <IconButton onClick={this.onEdit}><Edit /></IconButton>

                  </TableCell>
                  <TableCell>R${element.total.toFixed(2)}</TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>

      </div>
    )
  }
}

export default CartDetails
